import { render, staticRenderFns } from "./PuzzleOptionAnswerModal.vue?vue&type=template&id=75045aa4&scoped=true&"
import script from "./PuzzleOptionAnswerModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleOptionAnswerModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleOptionAnswerModal.vue?vue&type=style&index=0&id=75045aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75045aa4",
  null
  
)

export default component.exports